import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
import FormAdvancedOptions from "./FormAdvancedOptions";
import INITIAL_FORMDATA from "./_initialFormData";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval } = formData;
  const availableContent = [
    { label: "Global Traffic", value: "GTM" },
    { label: "Local Traffic", value: "LTM" },
    { label: "Mail logs", value: "MAIL" },
    { label: "Security", value: "SECURITY" },
    { label: "Traffic Manager Microkernel", value: "TMM" },
    { label: "User process", value: "USER" },
    { label: "Application messages", value: "MESSAGES" },
    { label: "Audit ", value: "AUDIT" },
    { label: "Daemon", value: "DAEMON" },
    { label: "Kernel", value: "KERNEL" },
    { label: "Webui", value: "WEBUI" }
  ];
  const [contentTypes, setContentTypes] = useState(INITIAL_FORMDATA.availableContents.value);
  const handleSubmit = () => {
    let error = false;
    formData.content_type.value = contentTypes;
    if (pollingInterval.value < 1) {
      setFormError({
        full_message: "Please provide valid polling interval",
        nice_message: "Minimum allowable polling interval is 1 minute."
      });
      error = true;
    }
    if (!error) {
      setFormError(null);
      onSubmit();
    }
  };
  return /* @__PURE__ */ React.createElement(FormWrap, { onSubmit: handleSubmit, buttonContent: "Proceed", title: "", error: formError, description: "" }, /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contents" }, "Logs Types to Collect"), /* @__PURE__ */ React.createElement(
    Select,
    {
      multi: true,
      name: "content_type",
      id: "content_type",
      onChange: (selected) => setContentTypes(selected),
      options: availableContent,
      value: contentTypes
    }
  ), /* @__PURE__ */ React.createElement("span", { className: "help-block" }, "The activity log for the above content types will be fetched."), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pollingInterval",
      name: "pollingInterval",
      type: "number",
      value: pollingInterval.value || pollingInterval.defaultValue || "",
      min: "1",
      max: "60",
      step: "1",
      onChange,
      required: true,
      help: "Determines how often (in minutes) the input will check for new data from F5. The smallest allowable interval is 1 minute.",
      label: "Polling Interval"
    }
  ), /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange }));
};
export default StepSubscribe;
